import { GridContentWidth, GridContainerAlignment } from './types.js';
import { Breakpoints, Media } from '@doordash/design-language';
import styled from 'styled-components';

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10;

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var NUM_COLUMNS = 12;

var getColumnWidth = function getColumnWidth(widthVal) {
  switch (widthVal) {
    case GridContentWidth.Full:
      return NUM_COLUMNS;

    case GridContentWidth.Half:
      return NUM_COLUMNS / 2;

    case GridContentWidth.Third:
      return NUM_COLUMNS / 3;

    case GridContentWidth.Quarter:
      return NUM_COLUMNS / 4;

    default:
      return widthVal;
  }
};

var getContainerMargin = function getContainerMargin(props) {
  switch (props.alignGrid) {
    case GridContainerAlignment.Start:
      return '0 auto 0 0';

    case GridContainerAlignment.End:
      return '0 0 0 auto';

    default:
      return '0 auto';
  }
};

var GridContainerWrapper = styled.div.withConfig({
  displayName: "styles__GridContainerWrapper",
  componentId: "sc-qnqnb5-0"
})(["display:grid;grid-column-gap:", ";grid-row-gap:", ";margin:", ";padding:0px ", "px;grid-template-columns:repeat(", ",1fr);width:100%;", ";", " ", "   ", " ", " ", ""], function (props) {
  return "".concat(props.columnGutter, "px");
}, function (props) {
  return "".concat(props.columnGutter, "px");
}, getContainerMargin, function (props) {
  return props.externalMargin;
}, NUM_COLUMNS, function (props) {
  return props.isFixed && "max-width: ".concat(props.customFixedWidth || Breakpoints.UltraWideScreen, "px");
}, Media.UltraWideScreen(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    ", "\n    ", "\n  "])), function (props) {
  return typeof props.externalMarginUltraWideScreen === 'number' && "padding: 0px ".concat(props.externalMarginUltraWideScreen, "px;");
}, function (props) {
  return typeof props.columnGutterUltraWideScreen === 'number' && "\n        grid-column-gap: ".concat(props.columnGutterUltraWideScreen, "px;\n        grid-row-gap: ").concat(props.columnGutterUltraWideScreen, "px;\n      ");
}), Media.WideScreen(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    ", "\n    ", "\n  "])), function (props) {
  return typeof props.externalMarginWideScreen === 'number' && "padding: 0px ".concat(props.externalMarginWideScreen, "px;");
}, function (props) {
  return typeof props.columnGutterWideScreen === 'number' && "\n        grid-column-gap: ".concat(props.columnGutterWideScreen, "px;\n        grid-row-gap: ").concat(props.columnGutterWideScreen, "px;\n      ");
}), Media.Desktop(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    ", "\n    ", "\n  "])), function (props) {
  return typeof props.externalMarginDesktop === 'number' && "padding: 0px ".concat(props.externalMarginDesktop, "px;");
}, function (props) {
  return typeof props.columnGutterDesktop === 'number' && "\n        grid-column-gap: ".concat(props.columnGutterDesktop, "px;\n        grid-row-gap: ").concat(props.columnGutterDesktop, "px;\n      ");
}), Media.Tablet(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    ", "\n    ", "\n  "])), function (props) {
  return typeof props.externalMarginTablet === 'number' && "padding: 0px ".concat(props.externalMarginTablet, "px;");
}, function (props) {
  return typeof props.columnGutterTablet === 'number' && "\n        grid-column-gap: ".concat(props.columnGutterTablet, "px;\n        grid-row-gap: ").concat(props.columnGutterTablet, "px;\n      ");
}), Media.Mobile(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n    ", "\n    ", "\n  "])), function (props) {
  return typeof props.externalMarginMobile === 'number' && "padding: 0px ".concat(props.externalMarginMobile, "px;");
}, function (props) {
  return typeof props.columnGutterMobile === 'number' && "\n        grid-column-gap: ".concat(props.columnGutterMobile, "px;\n        grid-row-gap: ").concat(props.columnGutterMobile, "px;\n      ");
}));
var GridContentWrapper = styled.div.withConfig({
  displayName: "styles__GridContentWrapper",
  componentId: "sc-qnqnb5-1"
})(["", ";padding:", ";", " ", " ", " ", " ", ""], function (props) {
  return props.columnWidthDefault === GridContentWidth.Hidden ? 'display: none' : "grid-column: span ".concat(getColumnWidth(props.columnWidthDefault));
}, function (props) {
  return "".concat(props.verticalPadding || props.internalPadding, "px ").concat(props.horizontalPadding || props.internalPadding, "px");
}, Media.UltraWideScreen(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n      ", ";\n      ", "\n  "])), function (props) {
  return props.columnWidthUltraWideScreen ? props.columnWidthUltraWideScreen === GridContentWidth.Hidden ? 'display: none' : "grid-column: span ".concat(getColumnWidth(props.columnWidthUltraWideScreen)) : undefined;
}, function (props) {
  return props.internalPaddingUltraWideScreen || props.horizontalPaddingUltraWideScreen || props.verticalPaddingUltraWideScreen ? "padding: ".concat(props.verticalPaddingUltraWideScreen || props.internalPaddingUltraWideScreen || props.internalPadding, "px ").concat(props.horizontalPaddingUltraWideScreen || props.internalPaddingUltraWideScreen || props.internalPadding, "px") : undefined;
}), Media.WideScreen(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n    ", ";\n      ", "\n  "])), function (props) {
  return props.columnWidthWideScreen ? props.columnWidthWideScreen === GridContentWidth.Hidden ? 'display: none' : "grid-column: span ".concat(getColumnWidth(props.columnWidthWideScreen)) : undefined;
}, function (props) {
  return props.internalPaddingWideScreen || props.horizontalPaddingWideScreen || props.verticalPaddingWideScreen ? "padding: ".concat(props.verticalPaddingWideScreen || props.internalPaddingWideScreen || props.internalPadding, "px ").concat(props.horizontalPaddingWideScreen || props.internalPaddingWideScreen || props.internalPadding, "px") : undefined;
}), Media.Desktop(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n    ", ";\n      ", "\n  "])), function (props) {
  return props.columnWidthDesktop ? props.columnWidthDesktop === GridContentWidth.Hidden ? 'display: none' : "grid-column: span ".concat(getColumnWidth(props.columnWidthDesktop)) : undefined;
}, function (props) {
  return props.internalPaddingDesktop || props.horizontalPaddingDesktop || props.verticalPaddingDesktop ? "padding: ".concat(props.verticalPaddingDesktop || props.internalPaddingDesktop || props.internalPadding, "px ").concat(props.horizontalPaddingDesktop || props.internalPaddingDesktop || props.internalPadding, "px") : undefined;
}), Media.Tablet(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n    ", ";\n      ", "\n  "])), function (props) {
  return props.columnWidthTablet ? props.columnWidthTablet === GridContentWidth.Hidden ? 'display: none' : "grid-column: span ".concat(getColumnWidth(props.columnWidthTablet)) : undefined;
}, function (props) {
  return props.internalPaddingTablet || props.horizontalPaddingTablet || props.verticalPaddingTablet ? "padding: ".concat(props.verticalPaddingTablet || props.internalPaddingTablet || props.internalPadding, "px ").concat(props.horizontalPaddingTablet || props.internalPaddingTablet || props.internalPadding, "px") : undefined;
}), Media.Mobile(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n    ", ";\n      ", "\n  "])), function (props) {
  return props.columnWidthMobile ? props.columnWidthMobile === GridContentWidth.Hidden ? 'display: none' : "grid-column: span ".concat(getColumnWidth(props.columnWidthMobile)) : undefined;
}, function (props) {
  return props.internalPaddingMobile || props.horizontalPaddingMobile || props.verticalPaddingMobile ? "padding: ".concat(props.verticalPaddingMobile || props.internalPaddingMobile || props.internalPadding, "px ").concat(props.horizontalPaddingMobile || props.internalPaddingMobile || props.internalPadding, "px") : undefined;
}));

export { GridContainerWrapper, GridContentWrapper };
